export default "__VITE_ASSET__C2qX6SpB__"